// Module
var code = "<% if (sl_icon) { %> <div class=\"striimline-icon {{sl_icon}}\"></div> <% } else { %> <i class=\"material-icons\">{{fa_class}}</i> <% } %> ";
// Exports
export default code;